module.exports = __webpack_public_path__ + "static/media/MD.1872fb6d.svg";